import { IChangePasswordDTO } from '@/models/admins.model';
import { ChangePasswordFieldsNames, TChangePasswordFieldsNamesValues } from '../helpers/types';

class ChangePasswordDTO implements IChangePasswordDTO {
  password;
  new_password;
  new_password_confirmation;

  constructor(values: TChangePasswordFieldsNamesValues) {
    this.password = values[ChangePasswordFieldsNames.OLD_PASSWORD];
    this.new_password = values[ChangePasswordFieldsNames.PASSWORD];
    this.new_password_confirmation = values[ChangePasswordFieldsNames.CONFIRM_PASSWORD];
  }
}

export default ChangePasswordDTO;
